import React, { FC, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col, Collapse } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { Form, Select } from "antd";
import { SocketTopics } from "constants/enums";
import { CID, RID } from "constants/localStoreKeys";
import { pushNotification } from "utils/notifications";
import { wrapRequestPayload } from "../../../../helpers/request/RequestPayload";
import { shareDispatchUrlPublishTopic } from "hooks/MQTTConstants";

const { TextArea } = Input;

const ShareDispatchUrlModal: FC<{ onClose: () => void; socket?: ISocket }> = (
  props
) => {
  const { onClose, socket } = props;
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [key, setKey] = useState("");
  const [registerForm] = Form.useForm();
  const [error, setError] = useState<string>("");
  const [saving, setSaving] = useState(false);
  const [type, setType] = useState("email");
  const { encrypted_token } = useSelector((state: RootState) => state.auth);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const dispatch = useDispatch();

  const onSubmitHandler = async (values: any) => {
    const { email, phone, nickname } = values;
    setError("");
    if (!email && !phone) {
      setError("Please enter email or phone number");
      return;
    }
    const notificationChannels = [];
    if (email) notificationChannels.push({ email });
    if (phone) notificationChannels.push({ phone });

    // setSaving(true);
    // setTimeout(()=>{
    //   setSaving(false);
    // }, 2000);

    // const data = {
    //     userIds: [{ email }, { phone: phone }],
    //   };

    // yield put({type: SHOW_PROGRESS})
    // const response = await verifyNewIds({ data });
    // if(response.status){

    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      shareDispatchUrlPublishTopic(encrypted_token?.connectionId),
      wrapRequestPayload({
        userId: encrypted_token?.userId,
        notificationChannels: {
          email,
          phone,
        },
        nickname,
      })
    );
    setIsModalVisible(false);
    onClose && onClose();
    // }
    // else{
    pushNotification("Link shared successfully", "success", "TOP_CENTER", 1000);
  };

  return (
    <Modal
      title="Share dispatch"
      visible={isModalVisible}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Form
        className="auth-form"
        name="register-form"
        id="register-form"
        layout="vertical"
        form={registerForm}
        onFinish={onSubmitHandler}
        requiredMark={false}
      >
        <Row>
          <Col span={8}>
            <Button
              onClick={() => {
                setType("email");
              }}
              className={`beam-btn ${
                type === "email" ? "green-btn cover" : ""
              }`}
            >
              Email
            </Button>
          </Col>
          <Col span={8}>
            <Button
              onClick={() => {
                setType("phone");
              }}
              className={`beam-btn ${
                type === "phone" ? "green-btn cover" : ""
              }`}
            >
              Phone
            </Button>
          </Col>
        </Row>

        <Row className="mt-4 mb-4">
          <Col span={24}>
            {type === "email" && (
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "The input is not valid Email!",
                  },
                  {
                    required: true,
                    message: "**Required field",
                  },
                ]}
              >
                <Input type="email" placeholder="Email" />
              </Form.Item>
            )}

            {type === "phone" && (
              <Form.Item
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "**Required field",
                  },
                ]}
              >
                <Input type="text" placeholder="Phone number (include +)" />
              </Form.Item>
            )}
            {error && (
              <Form.Item>
                <p className="error">{error}</p>
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row className="action-grp">
          <Col span={24} className="pr-2">
            <Form.Item>
              <Button
                className="beam-btn green-btn cover w-full"
                loading={saving}
                type="primary"
                htmlType="submit"
                onClick={() => setError("")}
              >
                Invite
              </Button>
            </Form.Item>
          </Col>
          {/* <Col span={10} className="pl-2">
            <Button
              className="beam-btn orange-btn bordered w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Col> */}
        </Row>
      </Form>
    </Modal>
  );
};

export default ShareDispatchUrlModal;
